import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ICellRendererParams } from 'ag-grid-community';
import { FC } from 'react';
import { IMetricsDataModel } from '../../../../../../../data-models/metrics.data-model';

const StyledTypography = styled(Typography)`
  line-height: 100%;
  width: 100%;
  text-align: right;
`;

const CellContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
`;

export const AcquisitionDataRenderer: FC<ICellRendererParams<IMetricsDataModel, number>> = (params) => {
  const { value, valueFormatted } = params;

  const formattedValue = (
    <StyledTypography noWrap variant='monotype'>
      {valueFormatted ?? value}
    </StyledTypography>
  );

  if (value == null && valueFormatted == null) {
    return null;
  }

  return <CellContainer>{formattedValue}</CellContainer>;
};
